import React from "react";
import { Routes, Route } from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";
import SignInPage from "./views/SignInView/SignInView";
import ServiceOverview from "./views/ServiceOverview/ServiceOverview";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import DashboardView from "./views/DashboardView/DashboardView";
import DetailView from "./views/DetailView/DetailView";
import "./App.css";
import AppHeader from "./components/AppHeader/AppHeader";

const App: React.FC = () => {
  const isAuthenticated = useIsAuthenticated();

  return (
    <>
      {isAuthenticated &&
      <AppHeader />}

      <Routes>
        {/* Public route */}
        <Route path="/" element={<SignInPage />} />

        {/* Protected route */}
        <Route
          path="/overview"
          element={
            <ProtectedRoute>
              <ServiceOverview />
            </ProtectedRoute>
          }
        />
        <Route
          path="/:service/dashboard"
          element={
            <ProtectedRoute>
              <DashboardView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/detail/:type/:label"
          element={
            <ProtectedRoute>
              <DetailView />
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
};

export default App;
